<script lang="ts" setup>
interface Props {
  modelValue?: boolean;
  disabled?: boolean;
  ariaLabel?: string;
}
const props = withDefaults(defineProps<Props>(), {
  modelValue: false,
  disabled: false,
  ariaLabel: undefined,
});
const emit = defineEmits<{
  'update:modelValue': [value: boolean];
}>();
function toggle() {
  if (!props.disabled) {
    emit('update:modelValue', !props.modelValue);
  }
}
</script>

<template>
  <button
    type="button"
    role="switch"
    :aria-checked="props.modelValue"
    :aria-label="props.ariaLabel"
    :disabled="props.disabled"
    :class="[
      $style.root,
      { [$style.checked]: props.modelValue, [$style.disabled]: props.disabled },
    ]"
    @click="toggle"
  >
    <span :class="$style.handle" />
  </button>
</template>

<style lang="scss" module>
.root {
  all: unset;
  box-sizing: border-box;
  display: inline-flex;
  align-items: center;
  justify-content: flex-start;
  width: 36px;
  height: 20px;
  padding: 2px;
  border-radius: 12px;
  background: var(--ui2-shade-black-16, rgba(0, 0, 0, 0.16));
  cursor: pointer;
  transition: background 0.2s ease;
  flex-shrink: 0;

  &:focus-visible {
    outline: 2px solid var(--ui2-state-focus, rgba(51, 85, 255, 1));
    outline-offset: 2px;
  }
}

.checked {
  background: var(--ui2-data-pine-forest, #226b6c);
  justify-content: flex-end;
}

.disabled {
  cursor: not-allowed;
  opacity: 0.48;
}

.handle {
  display: block;
  width: 16px;
  height: 16px;
  border-radius: 50%;
  background: var(--ui2-background-primary, #fff);
  box-shadow: 0 1px 4px 0 rgba(0, 0, 0, 0.24);
  flex-shrink: 0;
  transition: transform 0.2s ease;
}
</style>
